import "./index.scss";
import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import GuestApp from "../../assets/img/Featured/app-guest.png";
import Book from "../../assets/img/Featured/app-booking.png";
import Reserve from "../../assets/img/Featured/app-reservations.png";
import Loyalty from "../../assets/img/Featured/app-membership.png";
import Marketing from "../../assets/img/Featured/app-anniversary.png";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
const ContinousConnectionPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash connectionPage">
            <div className="background" />
            <Header />
            <div className="page-header">Continuous Connection</div>
            <div className="text-blocks">
                <div className="std-text">
                    Continue the guest connection post-stay to
                    transform service into hospitality, drive positive
                    reviews and encourage repeat visits. Surveys
                    enrich unified guest profiles and shape future
                    offers. Drive higher return visit spend with
                    personalized offers.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Continuous Connection", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={GuestApp} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Continuous Connection", "Book");
                    addFlow("Book");
                    navigate("/solutions/book")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book
                    </div>
                    <img src={Book} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Continuous Connection", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Continuous Connection", "Loyalty & Promotions");
                    addFlow("Loyalty & Promotions");
                    navigate("/solutions/loyalty")}}>
                    <div className="item-head">
                        <LogoMini />
                        Loyalty & Promotions
                    </div>
                    <img src={Loyalty} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Continuous Connection", "Digital Marketing");
                    addFlow("Digital Marketing");
                    navigate("/solutions/marketing")}}>
                    <div className="item-head">
                        <LogoMini />
                        Digital Marketing
                    </div>
                    <img src={Marketing} alt="" />
                </div>     
            </FeaturedSolutions>
        </div>
    )
}
export default ContinousConnectionPage;